import { EmptyState } from '@retailer-platform/shared-components/src/tds'
import { useDomainMessages } from '../../../../utils/intl'

export const MultipleContextsErrorState = () => {
  const messages = useDomainMessages({
    title: 'sharedEnterpriseToolsDomain.contextError.multipleContexts.title',
    description: 'sharedEnterpriseToolsDomain.contextError.multipleContexts.description',
  })

  return (
    <EmptyState icon="MagnifyingGlass" title={messages.title} description={messages.description} />
  )
}
